import { render, staticRenderFns } from "./Gemini.vue?vue&type=template&id=7e91a1ae"
import script from "./Gemini.vue?vue&type=script&lang=js"
export * from "./Gemini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports